import styles from "./draft-options.module.css";
import { useState } from "react";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { Toolbox } from "PosterEditor/sidebar/toolboxes/toolbox";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { useAuthContext } from "BEDROCK/auth/auth-provider";
import { useProjectStore } from "entity-store/project-store/use-project-store";
import { usePaths } from "BEDROCK/paths";

interface DraftOptionsProps {}

export const DraftOptions = (props: DraftOptionsProps) => {
  const [isShowingOverrideAlert, setIsShowingOverrideAlert] = useState(false);
  const { auth, home, mapEditor, navigateTo } = usePaths();
  const { deleteProjectAsync } = useProjectStore();
  const { saveDraft, deleteDraft, project, existingEditedDraftID } =
    usePosterProject();

  const startNew = async () => {
    await deleteDraft();
    setIsShowingOverrideAlert(false);
    saveDraft();
  };

  const continueProject = async () => {
    if (existingEditedDraftID) {
      await deleteProjectAsync(project);
      // `navigateTo` does not work because we're already at `/editor` and it doesn't reload.
      window.location.href = `/project/${existingEditedDraftID()}`;
    } else {
      navigateTo(home);
    }
  };

  return (
    <div className={styles.container}>
      <Toolbox collapsible={false} showTitleBar={false}>
        <div className={styles.content}>
          <h2>Discard existing project?</h2>
          <h3>
            If you customise this preset you'll <b>lose your changes</b>
          </h3>
        </div>
        <div className={styles.actions}>
          <CTAButton
            onClick={continueProject}
            variant="LINK"
            iconName="CHEVRON-LEFT"
            iconPosition="LEFT"
          >
            Existing project
          </CTAButton>
          <CTAButton
            onClick={startNew}
            variant="PRIMARY"
            iconName="CHEVRON-RIGHT"
            iconPosition="RIGHT"
          >
            Customise this preset
          </CTAButton>
        </div>
      </Toolbox>
    </div>
  );
};
